import { clsx } from 'clsx';
import * as styles from './styles.css';
import { TABLE_ROWS } from './constants';
import { LinkButton, useDeviceType } from '@cian/ui-kit';
import { MY_OFFERS } from 'shared/constants/links';

export const ServicesTypesTable: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['textblock']}>
        <div className={styles['title']}>Типы продвижения на&nbsp;Циан</div>
        <div className={styles['description']}>
          Чем сильнее услуга, тем больше потенциальных клиентов увидит ваше объявление
        </div>
      </div>
      <div className={styles['table-container']}>
        <table className={styles['table']}>
          <thead>
            <tr className={styles['table-header']}>
              <th></th>
              <th>Стандарт</th>
              <th>Премиум</th>
              <th>Топ</th>
              <th>Топ+Ставка</th>
            </tr>
          </thead>
          <tbody>
            {TABLE_ROWS.map(({ id, title, isBigImage, content }) => (
              <tr key={id} className={clsx(styles['table-row'], isBigImage && styles['max'])}>
                <td>{title}</td>
                {!isBigImage &&
                  content?.map(({ isText, value }, index) => (
                    <td key={index}>{isText ? value : <div className={styles[value]} />}</td>
                  ))}
                {isBigImage && (
                  <>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className={styles['btn']}>
        <LinkButton fullWidth href={MY_OFFERS} target="_blank" size="L">
          Подключить
        </LinkButton>
      </div>
    </div>
  );
};
